import React from 'react';

export default function Alert(props) {
  const tone = props.tone || 'error';

  return (
    <div
      className={'alert alert--' + tone}
      role={tone === 'error' ? 'alert' : 'status'}
    >
      <span className="alert__icon" aria-hidden="true">
        {tone === 'error' ? '!' : '✓'}
      </span>
      <div className="alert__body">{props.children}</div>
    </div>
  );
}
